
// export default 'data:audio/mp3;base64,audio-focus-test';
import gif from './gif';
export default gif;
//# sourceMappingURL=mp3.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ally.js/esm/supports/media/mp3.js
// module id = 210
// module chunks = 0 1